<div class="screen">
  <div class="side-panel">
    <mat-list>
      <mat-list-item class="list-item">
        <ng-container *ngIf="pinsLoaded">
          <mat-icon class="mat-icon-rtl-mirror" (click)="toggle_in = !toggle_in" style="cursor: pointer;">
            {{toggle_in ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
          <mat-checkbox
          (click)="allInputChecked()"
          [checked]="allSelectedIn()"
          [indeterminate]="partiallySelectedIn()"
          [disabled]="!pinsLoaded"
          ></mat-checkbox>
        </ng-container>
        <a matLine>{{ "IO.INPUT" | translate}}</a>
      </mat-list-item>

      <div [hidden]="!toggle_in">
        <mat-selection-list #input (selectionChange)="onInputSelectionChange(input.selectedOptions.selected)">
          <mat-list-option *ngFor="let pin of pins_in" checkboxPosition="before" class="list-options" [value]="pin" [selected]="allInputSelected">
            {{ pin }}
          </mat-list-option>
        </mat-selection-list>
      </div>

      <mat-list-item class="list-item">
        <ng-container *ngIf="pinsLoaded">
          <mat-icon class="mat-icon-rtl-mirror" (click)="toggle_out = !toggle_out" style="cursor: pointer;">
            {{toggle_out ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
          <mat-checkbox
          (change)="allOutputChecked()"
          [checked]="allSelectedOut()"
          [indeterminate]="partiallySelectedOut()"
          [disabled]="!pinsLoaded"
          ></mat-checkbox>
        </ng-container>
        <a matLine>{{ "IO.OUTPUT" | translate}}</a>
      </mat-list-item>

      <div [hidden]="!toggle_out">
        <mat-selection-list #output (selectionChange)="onOutputSelectionChange(output.selectedOptions.selected)">
          <mat-list-option *ngFor="let pin of pins_out" checkboxPosition="before" class="list-options" [value]="pin" [selected]="allOutputSelected">
            {{ pin }}
          </mat-list-option>
        </mat-selection-list>
      </div>
    </mat-list>
  </div>
  
  <div class="main-panel">
    <ng-container class="loading" *ngIf="this.loadingAll">
      <mat-progress-spinner mode="indeterminate" color="primary" diameter="35"></mat-progress-spinner>
    </ng-container>
    <ng-container *ngIf="inputSelected">
      <mat-expansion-panel [expanded]="expandIn" (closed)="expandIn=false">
        <mat-expansion-panel-header>
            <mat-panel-title><h3 class="header">{{ "IO.INPUT" | translate}}</h3></mat-panel-title>
            <mat-panel-description>
              <div class="description">
                <div>
                  <ng-container class="loading" *ngIf="this.loading">
                    <mat-progress-spinner mode="indeterminate" color="primary" diameter="35"></mat-progress-spinner>
                  </ng-container>
                </div>
                <div class="frequency">
                  {{'IO.FREQUENCY' | translate: { value: this.frequency} }}
                </div>
              </div>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="table-filter">
          <mat-form-field id="input">
              <mat-label>{{ "IO.FILTER" | translate}}</mat-label>
              <input matInput (keyup)="applyFilterInput($event)" placeholder="{{'IO.PLACEHOLDER' | translate}}" #input />
              <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        </div>
        <div class="table-input">
          <!-- table input - if input pin is checked -->
          <table mat-table [dataSource]="tableInput" #sortInput="matSort" matSort class="mat-elevation-z0">
              
            <!-- Pin Column -->
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by pin"> Pin </th>
              <td mat-cell *matCellDef="let element"> {{element.id}} </td>
            </ng-container>
          
            <!-- Label Column -->
            <ng-container matColumnDef="label">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by label"> Label </th>
              <td mat-cell *matCellDef="let element" [matTooltip]="element.label" [matTooltipDisabled]="element.label.length <= 29"> {{element.label.length > 29 ? element.label.slice(0,28) + "..." : element.label}} </td>
            </ng-container>
          
            <!-- DI Column -->
            <ng-container matColumnDef="di">
              <th mat-header-cell *matHeaderCellDef matTooltip="{{ 'IO.TOOLTIP.DI' | translate}}"> DI </th>
              <td mat-cell *matCellDef="let element"> {{element.di}} </td>
            </ng-container>
          
            <!-- aiv Column -->
            <ng-container matColumnDef="aiv">
              <th mat-header-cell *matHeaderCellDef matTooltip="{{ 'IO.TOOLTIP.AIV' | translate}}"> AIV (mV) </th>
              <td mat-cell *matCellDef="let element"> {{element.aiv}} </td>
            </ng-container>
  
            <!-- ri Column -->
            <ng-container matColumnDef="ri">
                <th mat-header-cell *matHeaderCellDef matTooltip="{{ 'IO.TOOLTIP.RI' | translate}}"> RI (&Omega;) </th>
                <td mat-cell *matCellDef="let element"> {{element.ri}} </td>
              </ng-container>
  
              <!-- fi Column -->
            <ng-container matColumnDef="fi">
                <th mat-header-cell *matHeaderCellDef matTooltip="{{ 'IO.TOOLTIP.FI' | translate}}"> FI (Hz) </th>
                <td mat-cell *matCellDef="let element"> {{element.fi}} </td>
              </ng-container>
  
              <!-- aic Column -->
            <ng-container matColumnDef="aic">
                <th mat-header-cell *matHeaderCellDef matTooltip="{{ 'IO.TOOLTIP.AIC' | translate}}"> AIC (&mu;A) </th>
                <td mat-cell *matCellDef="let element"> {{element.aic}} </td>
              </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="displayedColumnsInput; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsInput;"></tr>
          </table>
            
        </div>
      </mat-expansion-panel>

    </ng-container>
    <ng-container *ngIf="outputSelected">
      <mat-expansion-panel [expanded]="expandOut" (closed)="expandOut=false">
        <mat-expansion-panel-header>
            <mat-panel-title><h3 class="header">{{ "IO.OUTPUT" | translate}}</h3></mat-panel-title>
            <mat-panel-description>
              <div class="description">
                <div>
                  <ng-container class="loading" *ngIf="this.loading">
                    <mat-progress-spinner mode="indeterminate" color="primary" diameter="35"></mat-progress-spinner>
                  </ng-container>
                </div>
                <div class="frequency">
                  {{'IO.FREQUENCY' | translate: { value: this.frequency} }}
                </div>
              </div>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="table-filter">
          <mat-form-field id="input">
              <mat-label>{{ "IO.FILTER" | translate}}</mat-label>
              <input matInput (keyup)="applyFilterOutput($event)" placeholder="{{'IO.PLACEHOLDER' | translate}}" #input />
              <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        </div>
        <div class="table-output">
          <!-- table output - if output pin is checked-->
          <table mat-table [dataSource]="tableOutput" #sortOutput="matSort" matSort class="mat-elevation-z0">
              
            <!-- Pin Column -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by pin"> Pin </th>
                <td mat-cell *matCellDef="let element"> {{element.id}} </td>
              </ng-container>
            
              <!-- Label Column -->
              <ng-container matColumnDef="label">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by label"> Label </th>
                <td mat-cell *matCellDef="let element" [matTooltip]="element.label" [matTooltipDisabled]="element.label.length <= 29"> {{element.label.length > 29 ? element.label.slice(0,28) + "..." : element.label}} </td>
              </ng-container>
  
              <!-- PO Column -->
              <ng-container matColumnDef="po">
                <th mat-header-cell *matHeaderCellDef matTooltip="{{ 'IO.TOOLTIP.PO' | translate}}"> PO (mA) </th>
                <td mat-cell *matCellDef="let element"> {{element.po}} </td>
              </ng-container>
            
              <!-- DO Column -->
              <ng-container matColumnDef="do">
                <th mat-header-cell *matHeaderCellDef matTooltip="{{ 'IO.TOOLTIP.DO' | translate}}"> DO </th>
                <td mat-cell *matCellDef="let element"> {{element.do}} </td>
              </ng-container>
            
              <!-- aov Column -->
              <ng-container matColumnDef="aov">
                <th mat-header-cell *matHeaderCellDef matTooltip="{{ 'IO.TOOLTIP.AOV' | translate}}"> AOV (mV) </th>
                <td mat-cell *matCellDef="let element"> {{element.aov}} </td>
              </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="displayedColumnsOutput; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsOutput;"></tr>
          </table>
              
        </div>
      </mat-expansion-panel>

    </ng-container>
  </div>

</div>
    